import React, { useState } from "react";
import Form from 'react-bootstrap/Form'; 
import filterAdd from "../../images/icons/filter-add.png";
import userI from "../../images/icons/user.png";
import rolesI from "../../images/icons/roles.png";
import ppermiI from "../../images/icons/ppermi.png";
import { AiOutlineSearch, AiOutlinePlus } from "react-icons/ai";
import NavBar from "../NavBar/NavBar";
import RolesData from "./RolesData";
import "./User.scss";
import { Link } from "react-router-dom";

const Roles = () => {
  return (
    <>
        <NavBar />
        <main className="wrapper">
            <div className="page-content">
                <div className="wallbox-area">
                    <div className="pages-title">
                        <div className="h2">All Roles</div>
                        <span>View all roles in one table</span>
                    </div>
                    <div className="user__content">
                        <div className="user__data">
                            <ul className="panel_section">
                                <li>
                                    <span>Panel Selection</span>
                                </li>          
                                <li>
                                    <Link to="/user" ><img src={userI}/> Users</Link>
                                </li>          
                                <li>
                                    <Link to="/roles" className="active"><img src={rolesI}/> Roles</Link>
                                </li>          
                                <li>
                                    <Link to="/permissions" ><img src={ppermiI}/> Permissions</Link>
                                </li>          
                                <li className="additional_tt">
                                    <span>Additional Functions</span>    
                                </li>          
                                <li>
                                    <button><AiOutlinePlus/>Add new User</button>
                                </li>          
                            </ul>
                        </div>
                        <div className="user__data">
                            <div className="search-filter">
                                <form action="">
                                    <input type="search" placeholder="Search Product..." />
                                    <button type="submit"><AiOutlineSearch/></button>
                                </form>
                                <div className="sort-date">
                                    Sort by:
                                    <Form.Select aria-label="Default select example">
                                        <option>Date Installed</option>
                                        <option value="1">Start Installed</option>
                                        <option value="2">Timestamp</option>
                                        <option value="3">Start Installed</option>
                                    </Form.Select> 
                                </div>
                                <div className="filter">
                                    Filter <img src={filterAdd} />
                                </div>
                                <ul className="sort_check">
                                    <li>
                                        <div className="check">
                                            <span className="close">&#10006;</span>
                                            <span>User: >5</span>
                                        </div>
                                    </li> 
                                </ul>
                            </div>
                            <div className="wallbox-tabl">
                                <RolesData/>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </main>
    </>
  )
}

export default Roles